module.exports = __webpack_public_path__ + "static/media/Landing_page_Banner_Tablet@2x.b8a07dc1.jpg";